import { useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getCalle, getLocalidades, getProvincias } from "../../../../redux/actions/direccion";
import FormikAutocomplete from "../FormikAutocomplete";


export const handleChangeProvincia = (value, dispatch) => {
    return dispatch(getLocalidades(value)).then(() => {
        if (value === "Capital Federal") {
            dispatch(getCalle(value, value));
        }
    })
};

const FormikProvincia = ({ label, nameLocationFields }) => {
    const dispatch = useDispatch();


    const provincias = useSelector((state) => state.direccion.provincias);

    const { setFieldValue } = useFormikContext();




    return (
        <FormikAutocomplete
            name={nameLocationFields.provincia}
            label={label ? label : "Provincia *"}
            options={provincias.data}
            renderOption={(option) => option.nombre}
            filterOptions={(option) => option.nombre}
            fullWidth
            callBack={(value) => {
                if (value) {
                    handleChangeProvincia(value.id, dispatch);
                }
                setFieldValue(nameLocationFields.localidad, "");
                setFieldValue(nameLocationFields.calle, "");
                setFieldValue(nameLocationFields.numero, "");
                setFieldValue(nameLocationFields.codigoPostal, "");
            }}
            getOptions={() =>
                dispatch(getProvincias())
            }
        />
    )
}

export default FormikProvincia;